// extracted by mini-css-extract-plugin
module.exports = {"root":"PresentationItem_root__1yZ2O","edit_button":"PresentationItem_edit_button__12x83","delete_button":"PresentationItem_delete_button__1B_T3"};